module.exports = __webpack_public_path__ + "img/sim-img.9fa29fd4.png";